//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import interceptBackButton from '../intercept-back-button.js';
import SquareButton from './square-button.vue';
import {
  foldTask,
  unfoldTask,
  archiveItems,
  deleteItem,
  convertListToItem,
  clearColor,
  setTaskColor,
} from '../db-utils';
import {getCsrfToken} from "../session.js";
import {removeFromAllLayouts, colorArray} from '../utils.js';
import {defaultListID} from '../reactive-cache.js';

export default {
  props: {
    tasks: Array,
    section: Object,
  },
  components: {
    SquareButton,
  },
  data() {
    return {
      menuOpen: false,
      colorMenu: false,
      backdropEl: null,
      colorArray: colorArray,
      clearBackButtonHandler: null,
      // see comment in TopicBoard
      layoutId: this.$route.params.layoutId,
      layoutCustomizable: (
        this.section.doc && this.$route.params.layoutId.startsWith("layout:")
      ),
    };
  },
  computed: {
    isStatus() {
      return this.section.doc && this.section.doc.type === 'list' && this.section.doc.relation === 'status'
    },
    estimates() {
      return this.$settings && this.$settings.estimates === true;
    },
    listConversion() {
      return this.$settings && this.$settings.listConversion === true;
    },
    foldableCount() {
      let count = 0;
      for (const task of this.tasks) {
        if (task.getChildren().length > 2) {
          ++count;
        }
      }
      return count;
    },
    foldedCount() {
      let count = 0;
      for (const task of this.tasks) {
        if (task.localFolded) {
          ++count;
        }
      }
      return count;
    },
    selectedCount() {
      if (!this.$taskCardsController ||
          !this.$taskCardsController.selectedTasksIds) {
        return 0;
      }
      let count = 0;
      for (const task of this.tasks) {
        if (this.$taskCardsController.selectedTasksIds[task._id]) {
          ++count;
        }
      }
      return count;
    },
    allAreArchived() {
      for (const task of this.tasks) {
        if (!task.archivedTimestampMs) {
          return false
        }
      }
      return true;
    },
    currColumnIdx() {
      if (!this.layoutCustomizable) return -1;

      const layoutDoc = this.$reactiveCache.docs[this.layoutId];
      return layoutDoc.layout.indexOf(this.section.doc._id);
    },
    columnCount() {
      if (!this.layoutCustomizable) return -1;

      if (this.layoutId !== 'default') {
        return this.$reactiveCache.docs[this.layoutId].layout.length
      }
      return this.$root.subtaskOfLists.length
    },
    isDefaultList() {
      return Object.values(this.$sessionState.dbs)
                   .map(db => defaultListID(db))
                   .includes(this.section.doc._id)
    }
  },
  methods: {
    groupByTags() {
      this.section.doc.clone({groupByTags: true}).save()
    },
    ungroupByTags() {
      this.section.doc.clone({groupByTags: false}).save()
    },
    convertToTask() {
      const newId = convertListToItem(this.section.doc, 'task');
      this.$router.push('/task/' + newId);
    },
    foldAll() {
      for (const task of this.tasks) {
        foldTask(task);
      }
    },
    unfoldAll() {
      for (const task of this.tasks) {
        unfoldTask(task);
      }
    },
    selectAll() {
      for (const task of this.tasks) {
        this.$taskCardsController.select(task);
      }
    },
    unselectAll() {
      for (const task of this.tasks) {
        this.$taskCardsController.unselect(task);
      }
    },
    archiveAll() {
      this.$reactiveCache.freezeUntil(archiveItems(this.tasks, this));
    },
    setSectionTime() {
      const id = 'sectiondata:' + this.section.class + this.section.key
      const existingDoc = this.$reactiveCache.docs[id]
      const newValue = prompt(
        this.$gettext('How much time do you have available?'),
        existingDoc ? existingDoc.dur : ''
      );
      if (existingDoc) {
        const updated = existingDoc.clone();
        updated.dur = newValue;
        updated.save()
      } else {
        this.$defaultDB.put({
          _id: id,
          dur: newValue,
        })
      }
    },
    changeOwner() {
      this.$root.$emit(
        'share-dialog', {item: this.section.doc, dbs: this.$sessionState.dbs}
      )
    },
    changeSourceID() {
      const oldID = this.section.doc._id
      const newID = prompt(
        this.$gettext('ID of item (task/list) to show in this column/section:'),
        oldID,
      );
      if (newID === null) return;
      const item = this.$reactiveCache.docs[newID]
      if (!item) {
        alert(`Error: no list or item with ID "${newID}"`)
      } else {
        const layoutDoc = this.$reactiveCache.docs[this.layoutId]
        layoutDoc.layout[this.currColumnIdx] = newID
        layoutDoc.save()
      }
    },
    moveColumn(direction) {
      const layoutDoc = this.$reactiveCache.docs[this.layoutId]
      const layout = layoutDoc.layout
      const newIdx = direction === "right"
        ? this.currColumnIdx + 1
        : this.currColumnIdx - 1
      if (newIdx >= layout.length || newIdx < 0) {
        return  // already at the end
      }
      const moved = layout[this.currColumnIdx]
      layout.splice(this.currColumnIdx, 1)
      layout.splice(newIdx, 0, moved)
      layoutDoc.layout = layout.flat()
      layoutDoc.save()
    },
    removeFromCurrentLayout() {
      const layoutDoc = this.$reactiveCache.docs[this.layoutId]
      if (!layoutDoc) {
        console.error(`Invalid layout ID: "${this.layoutId}"`)
      } else {
        layoutDoc.layout.splice(this.currColumnIdx, 1)
        layoutDoc.save()
      }
    },
    archiveList() {
      archiveItems([this.section.doc], this);
      removeFromAllLayouts(this.section.doc._id, this.$reactiveCache);
    },
    deleteList() {
      const parentClass = this.section.doc._id.split(':')[0]
      const children = this.section.doc.getChildren();
      if (!children.length) {
        deleteItem(this.section.doc, this.$reactiveCache);
        removeFromAllLayouts(this.section.doc._id, this.$reactiveCache);
      } else {
        alert(
          `This ${parentClass} still has ${children.length} item(s) inside! `
          + "(Some may be hidden.)\nCannot delete."
        )
      }
    },
    async addTeamMember() {
      const db_name = this.section.couch.name
      const email = prompt(this.$gettext('Email address of the user to add:'));
      if (email == null) return;  // Prompt cancelled.
      try {
        await Vue.http.post('/add_team_member/', {db_name, email}, {
          headers: {'X-CSRFToken': getCsrfToken()},
          emulateJSON: true,
        });
        const successText = email + this.$gettext(
          ' added.\nNote: (s)he must reload the application to see changes.');
        console.info(successText);
        alert(successText);
        this.reloadPage()  // TODO: refresh list view without reload
      } catch (response) {
        console.error(response);
        const errText = `${response.statusText}: ${response.body}`;
        console.error(errText);
        alert(err,Text);
      }
    },
    setIcon() {
      const icon = prompt(
        this.$gettext('Material Design name. For a list, visit\n') +
        'https://fonts.google.com/icons?selected=Material+Icons'
      );
      if (icon) {
        this.section.doc.icon = icon;
        this.section.doc.save();
      }
    },
    changeColor(color) {
      if (color === "undefined") {
        clearColor(this.section.doc);
      } else {
        setTaskColor(this.section.doc, color);
      }
      this.colorMenu = false;
    },
    onOpened() {
      this.showBackdrop();
      this.clearBackButtonHandler = interceptBackButton(() => {
        this.menuOpen = false;
      });
    },
    onClosed() {
      if (this.clearBackButtonHandler) {
        this.clearBackButtonHandler();
        this.clearBackButtonHandler = null;
      }
      this.removeBackdrop();
    },
    showBackdrop() {
      if (!this.backdropEl) {
        this.backdropEl = document.createElement('div');
        this.backdropEl.classList.add('section-header-menu-backdrop');
        document.body.appendChild(this.backdropEl);
      }
    },
    removeBackdrop() {
      if (this.backdropEl) {
        this.backdropEl.remove();
        this.backdropEl = null;
      }
    },
  },
  beforeDestroy() {
    this.onClosed();
  },
};
